import { MeetingAttendeeIssue, MeetingAttendeeJoinMethod, MeetingAttendeeStatus } from '../api/attendees.dao';
import { AUTO_SYNC, CHANGED, CUSTOM, DEFAULT, EMPTY, EnablementStatus, NO, NONE, POPULATED, UNCHANGED, YES } from '../constants/common.constants';
import { NO_EDITED, NO_UNCHANGED, YES_EDITED, YES_UNCHANGED } from '../constants/mixpanel.constants';

export enum TRACKING_EVENTS {
    EDIT_EVENT = 'Edit event',
    NEW_EVENT = 'New event',
    EDIT_GUIDELINES = 'Edit Guidelines',
    AGENT_MEMORY_UPDATED = 'Agent Memory Updated',
    ATTENDEES_TAB_PAGE_LOAD = 'Attendees tab page load',
    ORGANIZATIONS_TAB_PAGE_LOAD = 'Organizations tab page load',
    NEW_CONNECTION = 'New Connection',
    EDIT_CONNECTION = 'Edit Connection',
    NEW_ATTENDEE = 'New Attendee',
    EDIT_ATTENDEE = 'Edit Attendee',
    NEW_ORGANIZATION = 'New organization',
    EDIT_ORGANIZATION = 'Edit Organization',
    CREATE_HUB_ORGANIZATION = 'Create Hub Organization',
    EDIT_HUB_ORGANIZATION = 'Edit Hub Organization',
    CREATE_HUB_ATTENDEE = 'Create Hub Attendee',
    EDIT_HUB_ATTENDEE = 'Edit Hub Attendee',
    DELETE_HUB_ATTENDEE = 'Delete Hub Attendee',
    DELETE_HUB_ORGANIZATION = 'Delete Hub Organization',
    DOWNLOAD_ATTENDEES_CSV = 'Download Attendees CSV',
    DOWNLOAD_PRESENTER_ORG_LINKS = 'Download Presenter Org Links',
    REPORTS_TAB_PAGE_LOAD = 'Reports tab page load',
    USERS_PAGE_LOAD = 'Users page load',
    NEW_USER = 'New User',
    EDIT_USER = 'Edit User',
    DELETE_USER = 'Delete User',
    DOWNLOAD_ALL_USERS = 'Download all users',
    DOWNLOAD_ALL_ACCOUNT_USERS = 'Download all account users',
    UPLOAD_REPORT = 'Upload report',
    DOWNLOAD_REPORT = 'Download report',
    EDIT_REPORT = 'Edit report',
    DELETE_REPORT = 'Delete report',
    EVENT_TRACKER_PAGE_LOAD_UPCOMING = 'Event Tracker page load - Upcoming',
    EVENT_TRACKER_PAGE_LOAD_PAST = 'Event Tracker page load - Past',
    EVENT_TRACKER_PAGE_LOAD_DELIVERED = 'Event Tracker page load - Delivered',
    ADD_LINKS = 'Add Links',
    EDIT_LINKS = 'Edit Links',
    FILTERING_BY_ANY_OF_THE_FILTERS = 'Filtering by any of the filters',
    EVENT_TRACKER_RESET_FILTER = 'Event Tracker - Reset Filter',
    SAVE_FILTERED_VIEW = 'Save Filtered view',
    SELECT_FILTERED_VIEW = 'Select Filtered view',
    EDIT_PLANNING_NOTES = 'Edit Planning notes',
    ADD_DELIVERY_TEAM = 'Add Delivery Team',
    CONFIGURE_PASSPORT_SETTINGS = 'Configure passport settings',
    CONFIGURE_EVENT_TITLE_AND_DESCRIPTION = 'Configure Event Title & Description',
    NEW_MEETING = 'New Meeting',
    EDIT_MEETING = 'Edit Meeting',
    DELETE_MEETING = 'Delete Meeting',
    DOWNLOAD_SCHEDULE = 'Download Schedule',
    SCHEDULE_TAB_PAGE_LOAD = 'Schedule tab page load',
    ACCOUNT_ADMIN_PAGE_LOAD = 'Account Admin page load',
    CONFIGURE_AI_AGENT_ACCESS = 'Configure AI Agent Access',
    ROLES_PAGE_LOAD = 'Roles page load',
    NEW_ROLE = 'New Role',
    EDIT_ROLE = 'Edit Role',
    MANAGE_PERMISSIONS = 'Manage Permissions',
    CONTROL_PAGE_FILTERS = 'Control Page Filters',
    CONTROL_PAGE_ACTIONS = 'Control Page Actions',
    CONTROL_PAGE_CONNECTION_DETAILS_POPOVER = 'Control Page Connection Details Popover',
    COPY_ATTENDEE_NAME_FROM_POPOVER = 'Copy Attendee Name from Popover',
    DELETE_CONNECTION = 'Delete Connection',
    CONNECTIONS_TAB_PAGE_LOAD = 'Connections tab page load',
    CONNECTIONS_TAB__CONNECTION_DETAILS_POPOVER = 'Connections tab Connection Details Popover',
    EDIT_MEETING_CONNECTIONS_ADD_CONNECTION = 'Edit Meeting Connections Add Connection',
    SCHEDULE_DATE_TIME_FILTER = 'Schedule tab Date & Time filter',
    SCHEDULE_ROOMS_FILTER = 'Schedule tab Rooms filter',
    SCHEDULE_MEETING_TYPE_FILTER = 'Schedule tab Meeting type filter',
    RUN_MEETING_ACTIONS = 'Run Meeting Actions',
    EDIT_MEETING_CONNECTIONS = 'Edit Meeting Connections',
    LOAD_ROOMS_TAB = 'Rooms Tab page load',
    NEW_ROOM = 'New Room',
    EDIT_ROOM = 'Edit Room',
    DELETE_ROOM = 'Delete Room',
    SIGN_IN_CONFIGURATION = 'Sign In Configuration',
    DOWNLOAD_ROOM_CONNECTIONS = 'Download Room Connections',
    DOWNLOAD_OPERATORS = 'Download Operators',
    DOWNLOAD_ALL_EVENTS_CONNECTIONS = 'Download All Events Connections',
    MY_SCHEDULE_PAGE_CONFIGURATION = 'My Schedule Page configuration',
    GENERAL_SESSIONS_PAGE_CONFIGURATION = 'General Sessions Configuration',
    SHOWCASE_PAGE_CONFIGURATION = 'Showcase Page Configuration',
    SUPPORT_PAGE_CONFIGURATION = 'Support Page Configuration',
    WELCOME_PAGE_CONFIGURATION = 'Welcome Page Configuration',
    SPEAKERS_PAGE_CONFIGURATION = 'Speakers Page Configuration',
    REPLAYS_PAGE_CONFIGURATION = 'Replays Page Configuration',
    GENERATE_ZOOM_REGISTRATION_REPORT = 'Generate Zoom Registration Report',
    EMAIL_TEMPLATES_CONFIGURATION = 'Email Templates Configuration',
    SEND_PREVIEW_BUTTON = 'Send Preview Button',
    NAVIGATION_CONFIGURATION = 'Navigation Configuration',
    CONFIGURE_REGISTRATION_FORM = 'Configure Registration Form',
    CONFIGURE_REGISTRATION_FORM_CUSTOM_FIELD = 'Add Custom field',
    CONFIGURE_REGISTRATION_FORM_PREVIEW = 'Preview button (Registration form)',
    DOWNLOAD_EVENT_REPORT = 'Download Event Report',
    GENERATE_EVENT_INTERACTIONS_REPORT = 'Generate Event Interactions Report',
    GENERATE_EVENT_REGISTRATION_REPORT = 'Generate Event Registration Report',
    GENERATE_ATTENDEES_INTERACTIONS_REPORT = 'Generate Attendees Interactions Report',
    GENERATE_REGISTRANTS_BY_SESSION_REPORT = 'Generate Registrants by Session Report',
    GENERATE_MEETING_INTERACTIONS_REPORT = 'Generate Meeting Interactions Report',
    GENERATE_MEETING_REGISTRATION_REPORT = 'Generate Meeting Registration Report',
    OPERATOR_TAB_PAGE_LOAD = 'Operators tab page load',
    OPERATOR_TAB_PAGINATION_USED = 'Operators tab pagination used',
    ADD_FOOTER_LINK = 'Add Footer Link',
    CUSTOM_CSS_CONFIGURATION = 'Custom CSS Configuration',
    MANAGE_URL_REDIRECTION = 'Manage URL Redirection',
    REGISTRATION_CONFIGURATION = 'Registration Configuration',
    USER_ACTIVATED_DEACTIVATED = 'User Activated / Deactivated',
    NEW_CUSTOM_PAGE = 'New Custom Page',
    EDIT_CUSTOM_PAGE = 'Edit Custom Page',
    SAVE_NEW_CONFIGURATION = 'Save Configuration',
    ACCOUNTS_LIST_PAGE_LOAD = 'Accounts list page load',
    DELETE_ACCOUNT = 'Delete Account',
    NEW_ACCOUNT = 'New Account',
    EDIT_ACCOUNT = 'Edit Account',
    NEW_USER_GROUP = 'New User Group',
    EDIT_USER_GROUP = 'Edit User Group',
    DELETE_USER_GROUP = 'Delete User Group',
    ASSETS_TAB_PAGE_LOAD = 'Assets Tab',
    UPLOAD_EVENT_ASSET = 'Upload event asset',
    DOWNLOAD_EVENT_ASSET = 'Download event asset',
    DELETE_EVENT_ASSET = 'Delete event asset',
    ADD_PROFILE_IMAGE = 'Add profile image',
    ADD_NEW_SCHEDULE_EMAIL = 'Add New Scheduled Email',
    EDIT_SCHEDULE_EMAIL = 'Edit Scheduled Email',
    REMOVE_SCHEDULE_EMAIL = 'Remove Scheduled Email',
    UPDATE_BIOGRAPHY = 'Update Biography',
    GENERATE_EVENT_REGISTRATION_TOKEN = 'Generate Event Registration Token',
    CREATE_KNOVIO_LIVE_PRESENTATION = 'Create Knovio from Central',
    KNOVIO_PREVIEW_CONNECTION = 'Preview Knovio from Connection info',
    CONFIGURE_PASSPORT_DISPLAY = 'Configure Passport Display',
    SYNC_SPEAKERS = 'Sync Speakers',
    CREATE_PANELIST_LINK = 'Create panelist link',
    DELETE_PANELIST_LINK = 'Delete Panelist link',
    SEARCH_PARTICIPANTS = 'Participants Popup: Search',
    ADD_MEETING_LINK = 'Add Meeting Link',
    EDIT_MEETING_LINK = 'Edit Meeting Link',
    COPY_MEETING_LINK = 'Copy Meeting Link',
}

export enum RUN_MEETING_EVENTS {
    STATUS_UPDATE = 'Status setup/update',
    VIEW_EVENT_GUIDELINES = 'View event guidelines',
    ATTENDEES_SEARCH = 'Attendees Search',
    ATTENDEE_JOIN_CHECK = 'Attendee Join check',
    REPORT_STATUS = 'Report Status',
    ATTENDEE_NOTE = 'Attendee Note',
    ATTENDEE_JOIN_LATE_CHECK = 'Attendee Join Late check',
    COPY_ATTENDEE_NAME = 'Copy attendee name',
    AV_SETUP = 'AV setup',
    REPORT_ISSUE = 'Report Issue',
    ADD_WALK_IN_PRESENTER = 'Add Walk-In Presenter',
    ADD_WALK_IN_PARTICIPANT = 'Add Walk-In Participant',
    ADD_WALK_IN_HOST = 'Add Walk-In Host',
    OPERATOR_MEETING_NOTES = 'Operator Meeting Notes',
    EDIT_MEETING_CONNECTIONS = 'Edit Meeting Connections',
    ADD_MEETING_LINK = 'Add Meeting Link',
    EDIT_MEETING_LINK = 'Edit Meeting Link',
    COPY_MEETING_LINK = 'Copy Meeting Link',
    CANCEL_MEETING = 'Cancel Meeting',
    OPERATOR_SHARED_SCREEN = 'Operator Shared Screen',
}

export enum BLUEPRINTS_TRACKING_EVENTS {
    NEW_EVENT_BLUEPRINT = 'New Event Blueprint',
    EDIT_EVENT_BLUEPRINT = 'Edit Event Blueprint',
    DELETE_EVENT_BLUEPRINT = 'Delete Event Blueprint',
    NEW_CONNECTION_TEMPLATE = 'New Connection Template',
    EDIT_CONNECTION_TEMPLATE = 'Edit Connection Template',
    DELETE_CONNECTION_TEMPLATE = 'Delete Connection Template',
    NEW_MEETING_TEMPLATE = 'New Meeting Template',
    NEW_ORDER_TEMPLATE = 'New Order Template',
    EDIT_MEETING_TEMPLATE = 'Edit Meeting Template',
    DELETE_MEETING_TEMPLATE = 'Delete Meeting Template',
}

export enum AI_FEATURE_TRACKING_EVENTS {
    GENERATE_AI_IMAGE = 'Generate AI Image',
    USE_AI_IMAGE = 'Use AI Image',
    AI_IMAGE_GENERATION_TRY_AGAIN = 'AI Image Generation Try Again',
    SEND_REQUEST_TO_AI_MEETING_COPILOT = 'Send Request to AI Meeting Co-Pilot',
    CREATE_MEETING_WITH_AI_MEETING_COPILOT = 'Create Meeting with AI Meeting Co-Pilot'
}

export enum ACTION_STATUS {
    Success = 'Success',
    Failed = 'Failed'
}

export const RUN_MEETING_ATTENDEE_ISSUE_MAPPER = {
    [MeetingAttendeeIssue.BAD_AUDIO]: 'Bad Audio',
    [MeetingAttendeeIssue.BAD_VIDEO]: 'Bad Video',
    [MeetingAttendeeIssue.CONNECTION_DROPPED]: 'Connection Dropped'
};

export const RUN_MEETING_ATTENDEE_JOIN_METHOD_MAPPER = {
    [MeetingAttendeeJoinMethod.AUDIO]: 'Audio',
    [MeetingAttendeeJoinMethod.VIDEO]: 'Video',
    [MeetingAttendeeJoinMethod.IN_PERSON]: 'In-Person'
};

export const RUN_MEETING_ATTENDEE_STATUS_MAPPER = {
    [MeetingAttendeeStatus.NOSHOW]: 'No Show',
    [MeetingAttendeeStatus.CANCELLED]: 'Cancelled'
};

export enum OpenFrom {
    Schedule = 'Schedule tab',
    Control = 'Control tab',
    Connections = 'Connections tab',
    Attendees = 'Attendees tab',
    Organizations = 'Organizations tab',
    RunMeeting = 'Run meeting popup',
    Rooms = 'Rooms tab',
    Passport = 'Passport tab',
    Reports = 'Reports tab',
    EditMeetingConnections = 'Edit Meeting Connections',
    EditRoomPopup = 'Edit room popup',
    RegistrantsListInParticipantPopup = 'Registrants List in Participants Pop Up',
}

export enum CONTROL_PAGE_TRACKING_EVENTS {
    GET_ARTIFACTS = 'Get Artifacts (Control tab)',
    VIEW_GUIDELINES = 'View Guidelines',
    OPEN_PARTICIPANTS_POPUP = 'Open Participants Pop up',
    JOINED_TAB_PARTICIPANTS_POPUP = 'Joined tab in Participants Pop up',
    REGISTRANTS_TAB_PARTICIPANTS_POPUP = 'Registrants tab in Participants Pop up',
}

export enum ARTIFACTS_PAGE_TRACKING_EVENTS {
    DOWNLOAD_ARTIFACT = 'Download Artifact',
    DELETE_ARTIFACT = 'Delete Artifact',
    GENERATE_ARTIFACTS_IN_BATCH = 'Generate Artifacts in Batch',
    ARTIFACTS_TAB_PAGE_LOAD = 'Artifacts Tab',
    GENERATE_PASSPORT_REPLAYS = 'Generate Passport Replay',
    PUBLISH_ARTIFACT = 'Publish Artifact',
}

export enum ASSETS_PAGE_TRACKING_EVENTS {
    CREATE_ASSET_DOWNLOAD_LINK = 'Create Asset Download Link'
}

export enum SALESFORCE_ORDER_TRACKING_EVENTS {
    VIEW_SALESFORCE_ORDER = 'View Salesforce Order',
    CREATE_SALESFORCE_ORDER = 'Create SF Order Created',
    LINK_SALESFORCE_ORDER = 'SF Order Linked',
    EDIT_SALESFORCE_ORDER = 'SF Order Edited',
    SF_ORDER_PRODUCTS_UPDATED = 'SF Order Products Updated',
}

export enum CONNECTION_DETAILS_POPOVER_TRACKING_EVENTS {
    CALL = 'Call Connection Details popover from page',
    COPY_DATA = 'Copy data from Connection Details popover',
    CLONE_CONNECTION = 'Clone connection from Connection Details popover',
    EDIT_CONNECTION = 'Edit Connection from Connection Details popover',
    DELETE_CONNECTION = 'Delete Connection from Connection Details popover',
    NAVIGATE_HOST_BUTTON = 'Click Host',
    NAVIGATE_JOIN_BUTTON = 'Click Join',
    WEBINAR_CONNECTION_REPORT_REGISTRATION = 'Webinar Connection Report - Registration',
    WEBINAR_CONNECTION_REPORT_ATTENDEE = 'Generate Zoom Attendee Report',
    TROUBLESHOOT_CONNECTION = 'Troubleshoot Connection',
}

export enum ATTENDEE_INFO_POPOVER_TRACKING_EVENTS {
    CALL = 'Call Attendee info popover',
    OPENED_FROM = 'Opened From'
}

export type TAttendeeInfoPopoverTrackingValues = `${ATTENDEE_INFO_POPOVER_TRACKING_EVENTS}`;

export enum EMAIL_TEMPLATES_EVENTS {
    CREATE_EMAIL_TEMPLATE = 'Create Email Template',
    EDIT_EMAIL_TEMPLATE = 'Edit Email Template',
    DELETE_EMAIL_TEMPLATE = 'Delete Email Template',
    GENERATE_CONNECTIONS_EMAIL_TEXT = 'Generate Connections Email Text',
    COPY_CONNECTIONS_EMAIL_TEXT = 'Copy Connections Email Text',
    SEND_CONNECTIONS_EMAIL = 'Send Connections Email',
}

export type RolodexContactEvents = 'Edit OE Contact Profile'
    | 'Record Contact Pronunciation'
    | 'Remove Contact Pronunciation'
;

export enum LogoType {
    OE_LOGO = 'OE Logo',
    CUSTOM_LOGO = 'Custom Logo',
    NO_LOGO = 'No Logo'
}

export enum CONNECTION_GROUP_TRACKING_EVENTS {
    NEW_CONNECTION_GROUP = 'New Connection Group',
    EDIT_CONNECTION_GROUP = 'Edit Connection Group',
    DELETE_CONNECTION_GROUP = 'Delete Connection Group'
}

export enum EVENT_HUB_TRACKING_EVENTS {
    CREATE_EVENT_HUB = 'Create Event Hub',
    EDIT_EVENT_HUB = 'Edit Event Hub',
    DELETE_EVENT_HUB = 'Delete Event Hub',
    CONFIGURE_HUB_REGISTRATION = 'Configure Hub Registration',
    CONFIGURE_HUB_SIGN_IN = 'Configure Hub Sign In',
}

export enum OE_DATA_TRACKING_EVENTS {
    VIEW_OE_DATA = 'View OE Data',
}

export type TFilterName = 'Date'
    | 'Account'
    | 'Region'
    | 'Business Line'
    | 'Type'
    | 'Coordinators'
    | 'Delivery Team'
    | 'Links'
    | 'Clear All Filters'
    | 'Search'
    | 'Columns'
    | null
;

export const filtersTrackingValuesMapper: Record<string, TFilterName> = {
    'Accounts': 'Account',
    'Types': 'Type',
    'Coordinators': 'Coordinators',
    'Delivery Team': 'Delivery Team',
    'Links': 'Links',
    'Regions': 'Region',
    'Business Lines': 'Business Line',
};

export type TSelectedFilterOptions = {
    selectedFilter: TFilterName;
    isReseted?: boolean;
};

export const convertBoolTypeForMixPanel = (value: boolean): string => value ? YES : NO;

export const convertBoolTypeEmptyForMixPanel = (value: boolean): string => value ? YES : NONE;

export const convertBoolToDefaultOrCustomTypeForMixPanel = (value: boolean): string => value ? DEFAULT : CUSTOM;

export const isTrackingFieldEnabled = (value: boolean): string => value ? EnablementStatus.ENABLED_UPPERCASE : EnablementStatus.DISABLED_UPPERCASE;

export const isTrackingFieldPopulated = (value: string): string => value ? POPULATED : EMPTY;

export const isTrackingFieldChanged = (value: boolean): string => value ? CHANGED : UNCHANGED;

export const isTrackingFieldEnabledOrAutoSync = (value: boolean): string => value ? AUTO_SYNC : EnablementStatus.DISABLED_UPPERCASE;

export const handleTrackingValueChanges = (initialValue: string, changedValue: string): string => {
    if (!initialValue && !changedValue) return NO_UNCHANGED;
    if (!!initialValue && !changedValue) return NO_EDITED;
    if (initialValue === changedValue) return YES_UNCHANGED;
    if (initialValue !== changedValue) return YES_EDITED;
    return '';
};
